import React from "react";

const Stat_Study_Types = () => {
  return (
    <div>
      <h1>Stat Study Types</h1>
    </div>
  );
};

export default Stat_Study_Types;
